class HaloBackToTop extends HTMLElement {
  constructor() {
    super();
    this.threshold = 600;
    this.ticking = false;
    this.onScroll = this.onScroll.bind(this);

    this.addEventListener('click', (event) => {
      if (!event.target.closest('button')) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });

    this.addEventListener('transitionend', () => {
      const btn = this.querySelector('button');
      if (btn && !btn.classList.contains('is-visible')) btn.hidden = true;
    });
  }

  connectedCallback() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
    requestAnimationFrame(() => this.update());
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    if (!this.ticking) {
      this.ticking = true;
      requestAnimationFrame(() => this.update());
    }
  }

  update() {
    this.ticking = false;
    const btn = this.querySelector('button');
    if (!btn) return;
    if (window.scrollY > this.threshold) {
      btn.hidden = false;
      requestAnimationFrame(() => btn.classList.add('is-visible'));
    } else {
      btn.classList.remove('is-visible');
    }
  }
}

if (!customElements.get('halo-back-to-top')) {
  customElements.define('halo-back-to-top', HaloBackToTop);
}
